module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui blue card",
    attrs: {
      "id": _vm.task.id
    },
    on: {
      "click": _vm.openTask
    }
  }, [_c('a', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm._topContent)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.formattedTaskDescription) + "\n\t")]), _vm._v(" "), (_vm._tags.length > 0) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm._tags), function(tag) {
    return _c('div', {
      class: _vm.getTagClass(tag)
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formattedTag(tag)) + "\n\t\t")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "extra content",
    domProps: {
      "innerHTML": _vm._s(_vm._extraContent)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2310f642","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backlogCard.vue
// module id = 245
// module chunks = 1